import { render, staticRenderFns } from "./HeadU680.vue?vue&type=template&id=44b0b07e&scoped=true"
import script from "./HeadU680.vue?vue&type=script&lang=js"
export * from "./HeadU680.vue?vue&type=script&lang=js"
import style0 from "./HeadU680.vue?vue&type=style&index=0&id=44b0b07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b0b07e",
  null
  
)

export default component.exports